/* Pump tools: product data check — drumpump.com
 * A page for the store team. Reads the same product feed and chemical file as Find My Pump and Shop by Chemical and lists
 * every product the tools leave out or cannot rate, and why, so the fix is a metafield edit or a Matrixify re-import.
 * Needs pump-engine.js, loaded first. Changes nothing.
 */
(function () {
  'use strict';
  var PE = window.PumpEngine;
  function arr(v) { return Array.isArray(v) ? v : []; }
  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { if (attrs[k] != null) e.setAttribute(k, attrs[k]); });
    (children || []).forEach(function (c) { if (c != null && c !== false) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  function shopRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function getJson(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); }); }
  function fetchProducts(root) {
    var direct = root.getAttribute('data-products-url');
    if (direct) return getJson(direct).then(function (j) { return j.products || j; });
    var handle = root.getAttribute('data-collection') || 'find-my-pump';
    function page(n) { return getJson(shopRoot() + 'collections/' + encodeURIComponent(handle) + '?view=fmp-json&page=' + n); }
    return page(1).then(function (first) {
      var rest = []; for (var n = 2; n <= (first.pages || 1); n++) rest.push(page(n));
      return Promise.all(rest).then(function (others) { return others.reduce(function (acc, o) { return acc.concat(o.products || []); }, first.products || []); });
    });
  }
  // Values the tools' filters, questions and scoring know about
  function knownValues(sbcRules, fmpRules, data) {
    var containers = [], power = [], features = [];
    function add(list, v) { if (v && list.indexOf(v) < 0) list.push(v); }
    arr(sbcRules.filters && sbcRules.filters.container && sbcRules.filters.container.options).forEach(function (o) { arr(o[1]).forEach(function (v) { add(containers, v); }); });
    var cq = (fmpRules.questions || {}).container || {};
    arr(cq.options).concat(arr(cq.grease_options)).forEach(function (o) { arr(o.tags).forEach(function (v) { add(containers, v); }); });
    arr(sbcRules.filters && sbcRules.filters.power && sbcRules.filters.power.options).forEach(function (o) { arr(o[1]).forEach(function (v) { add(power, v); }); });
    var fb = ((fmpRules.scoring || {}).feature_bonus) || {};
    Object.keys(fb).forEach(function (group) { if (group.charAt(0) !== '_') Object.keys(fb[group] || {}).forEach(function (k) { add(features, k); }); });
    var fluidTags = arr(data && data.fluid_types).concat(Object.keys((data && data.listed) || {}));
    return { containers: containers, power: power, features: features, fluid_tags: fluidTags.length ? fluidTags : null };
  }

  var LEVELS = [
    ['excluded', 'Left out of both tools', 'Customers never see these pumps in Find My Pump or Shop by Chemical until the field is fixed.'],
    ['unrated', 'Not rated for any chemical', 'Shown when browsing and in Find My Pump’s fluid questions, but never for a named chemical: the chart fields are wrong.'],
    ['warning', 'Check these', 'Shown, but a field is empty or has a value the tools do not use.']
  ];

  function mount(root) {
    if (root.__pdc) return;
    root.__pdc = true;
    var status = el('p', { class: 'pdc-muted' }, ['Loading the product feed…']);
    root.appendChild(status);
    Promise.all([
      PE ? Promise.resolve() : Promise.reject(new Error('pump-engine.js is not loaded')),
      getJson(root.getAttribute('data-chemicals')), getJson(root.getAttribute('data-sbc-rules')), getJson(root.getAttribute('data-fmp-rules')), fetchProducts(root)
    ]).then(function (res) { status.remove(); render(root, res[1], res[2], res[3], res[4]); })
      .catch(function (err) { status.textContent = 'Could not load: ' + err.message; });
  }

  function issueTable(list) {
    var table = el('table', { class: 'pdc-table' }, [el('thead', {}, [el('tr', {}, [el('th', {}, ['Product']), el('th', {}, ['Vendor']), el('th', {}, ['Metafield']), el('th', {}, ['What to fix'])])])]);
    var body = el('tbody');
    list.slice().sort(function (a, b) { return (a.p.title || '').localeCompare(b.p.title || '') || a.issue.field.localeCompare(b.issue.field); }).forEach(function (r) {
      body.appendChild(el('tr', {}, [
        el('td', {}, [el('a', { href: r.p.url, target: '_blank', rel: 'noopener' }, [r.p.title || r.p.handle]), r.p.id ? el('a', { class: 'pdc-admin', href: '/admin/products/' + r.p.id, target: '_blank', rel: 'noopener' }, ['Edit']) : null]),
        el('td', {}, [r.p.vendor || '']),
        el('td', {}, [el('code', {}, ['custom.' + r.issue.field])]),
        el('td', {}, [r.issue.message])
      ]));
    });
    table.appendChild(body);
    return el('div', { class: 'pdc-scroll' }, [table]);
  }

  function render(root, data, sbcRules, fmpRules, products) {
    var known = knownValues(sbcRules, fmpRules, data);
    var inTools = products.filter(PE.inTools), rows = [];
    inTools.forEach(function (p) { PE.productIssues(p, data, known).forEach(function (i) { rows.push({ p: p, issue: i }); }); });
    var count = function (level) { var seen = {}; rows.forEach(function (r) { if (r.issue.level === level) seen[r.p.handle] = true; }); return Object.keys(seen).length; };
    var usable = inTools.filter(function (p) { return PE.usable(p, data); });
    var charted = usable.filter(function (p) { return PE.chart(p, data); });

    root.appendChild(el('p', { class: 'pdc-lede' }, ['Checked ' + new Date().toLocaleString() + ' against ' + products.length + ' products in the feed. Chemical data version ' + (data.version || '?') + '.']));
    var tiles = [
      [String(usable.length), 'in the tools', 'of ' + inTools.length + ' switched on (wizard_enabled, pump or package)'],
      [String(count('excluded')), 'left out', 'missing or invalid required field'],
      [String(charted.length), 'rated by a chart', Object.keys(data.sources || {}).map(function (id) { return data.sources[id].label + ' ' + charted.filter(function (p) { return p.rating_source === id; }).length; }).join(' · ')],
      [String(count('unrated')), 'chart fields wrong', 'rating_source or rating_key'],
      [String(count('warning')), 'to check', 'shown, but worth a look']
    ];
    root.appendChild(el('div', { class: 'pdc-tiles' }, tiles.map(function (t) {
      return el('div', { class: 'pdc-tile' + ((t[1] === 'left out' || t[1] === 'chart fields wrong') && t[0] !== '0' ? ' is-bad' : '') }, [el('strong', {}, [t[0]]), el('span', {}, [t[1]]), el('small', {}, [t[2]])]);
    })));

    LEVELS.forEach(function (lv) {
      var list = rows.filter(function (r) { return r.issue.level === lv[0]; }), n = count(lv[0]);
      var sec = el('section', { class: 'pdc-block' }, [el('h2', {}, [lv[1] + ' (' + n + ' product' + (n === 1 ? '' : 's') + ')']), el('p', { class: 'pdc-muted' }, [lv[2]])]);
      sec.appendChild(list.length ? issueTable(list) : el('p', { class: 'pdc-ok' }, ['Nothing to fix.']));
      root.appendChild(sec);
    });

    // Upgrade parts: sold as their own products, offered with the pumps that accept them
    var parts = PE.partsReport(products, data);
    if (parts.rows.length || parts.issues.length) {
      var missing = parts.rows.filter(function (r) { return r.missing; });
      var psec = el('section', { class: 'pdc-block' }, [
        el('h2', {}, ['Upgrade parts (' + parts.rows.length + ')']),
        el('p', { class: 'pdc-muted' }, ['Parts a manufacturer asks for in a condition. A pump that can take a part lists it in accepts_upgrades and is shown with the part as a required upgrade; a pump that has it built in lists it in includes_upgrades and is rated as sold. The product that sells a part needs wizard_role part, upgrade_part and the fmp tag.'])
      ]);
      if (missing.length) psec.appendChild(el('p', { class: 'pdc-bad' }, [missing.length + ' part' + (missing.length === 1 ? ' is' : 's are') + ' accepted by pumps but not sold by any product in the feed.']));
      var list = function (ps) {
        if (!ps.length) return el('span', { class: 'pdc-muted-inline' }, ['None']);
        var det = el('details', {}, [el('summary', {}, [ps.length + ' pump' + (ps.length === 1 ? '' : 's')])]);
        det.appendChild(el('ul', {}, ps.map(function (p) { return el('li', {}, [el('a', { href: p.url, target: '_blank', rel: 'noopener' }, [p.title || p.handle])]); })));
        return det;
      };
      var ptable = el('table', { class: 'pdc-table pdc-parts' }, [el('thead', {}, [el('tr', {}, [el('th', {}, ['Part']), el('th', {}, ['Sold as']), el('th', {}, ['Accepted by']), el('th', {}, ['Built into'])])])]);
      var pbody = el('tbody');
      parts.rows.forEach(function (r) {
        pbody.appendChild(el('tr', { class: r.missing ? 'is-bad' : null }, [
          el('td', {}, [el('code', {}, [r.id]), el('div', {}, [r.label])]),
          el('td', {}, r.product ? [el('a', { href: r.product.url, target: '_blank', rel: 'noopener' }, [r.product.title || r.product.handle]), r.product.id ? el('a', { class: 'pdc-admin', href: '/admin/products/' + r.product.id, target: '_blank', rel: 'noopener' }, ['Edit']) : null]
                                  : [el('strong', {}, [r.missing || 'Not sold in the feed. No pump accepts it yet.'])]),
          el('td', { 'data-label': 'Accepted by' }, [list(r.accepted)]),
          el('td', { 'data-label': 'Built into' }, [list(r.included)])
        ]));
      });
      ptable.appendChild(pbody);
      psec.appendChild(el('div', { class: 'pdc-scroll' }, [ptable]));
      if (parts.issues.length) {
        psec.appendChild(el('h3', {}, ['Part products to fix (' + parts.issues.length + ')']));
        psec.appendChild(issueTable(parts.issues.map(function (i) { return { p: i.p, issue: i }; })));
      }
      root.appendChild(psec);
    }

    // Products with no chart are normal (not every pump has one) but a pump from a brand with a chart should not be here
    var noChart = usable.filter(function (p) { return !p.rating_source && !p.rating_key; });
    var byVendor = {};
    noChart.forEach(function (p) { var v = p.vendor || '(no vendor)'; (byVendor[v] = byVendor[v] || []).push(p); });
    var sec = el('section', { class: 'pdc-block' }, [
      el('h2', {}, ['No chart (' + noChart.length + ')']),
      el('p', { class: 'pdc-muted' }, ['These pumps have no rating_source, so they are never shown for a named chemical. That is right for pumps whose manufacturer publishes no chart. If a pump from a brand with a chart is listed here, fill in rating_source and rating_key.'])
    ]);
    sec.appendChild(el('ul', { class: 'pdc-vendors' }, Object.keys(byVendor).sort().map(function (v) {
      var det = el('details', {}, [el('summary', {}, [v + ': ' + byVendor[v].length])]);
      det.appendChild(el('ul', {}, byVendor[v].map(function (p) { return el('li', {}, [el('a', { href: p.url, target: '_blank', rel: 'noopener' }, [p.title])]); })));
      return el('li', {}, [det]);
    })));
    root.appendChild(sec);

    var off = products.filter(function (p) { return !PE.inTools(p) && p.role !== PE.PART_ROLE; });
    if (off.length) root.appendChild(el('section', { class: 'pdc-block' }, [
      el('h2', {}, ['Switched off (' + off.length + ')']),
      el('p', { class: 'pdc-muted' }, ['In the feed collection but not in the tools: wizard_enabled is not true, or wizard_role is not pump or package. Upgrade part products are listed under Upgrade parts.'])
    ]));
  }

  var boot = function (scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pump-data-check]'), mount); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(); }) : boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
